import React, { FC, useEffect } from "react";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import FeatherIcon from "feather-icons-react";

import {
  StyledListItemIcon,
  StyledListItemText,
  StyledMenuItem,
} from "../../ActionsDropdown.styled";

import { useExportFormConfig } from "@api";
import { useUserStore } from "@store/user";
import { useMultistepFormStore } from "@components/common/MultistepForm/MultistepForm.store";
import BackdropLoader from "@components/common/BackdropLoader";

interface FormConfigExport {}

const FormConfigExport: FC<FormConfigExport> = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useUserStore();
  const {
    exportFormConfig,
    exportFormConfigEnabled,
    isPendingExportFormConfig,
    isErrorExportFormConfig,
  } = useExportFormConfig(user);
  const {
    formSettings: {
      formBasics: { id: formId, code },
    },
  } = useMultistepFormStore();

  const handleExport = async (): Promise<void> => {
    await exportFormConfig({
      formId,
      filename: `form-config-${code}-${formId}.json`,
    });
  };

  useEffect(() => {
    if (isErrorExportFormConfig) {
      enqueueSnackbar(
        t("forms.errorExportingFormConfig", "Exporting form configuration failed"),
        {
          variant: "error",
        },
      );
    }
  }, [isErrorExportFormConfig, enqueueSnackbar, t]);

  return (
    exportFormConfigEnabled && (
      <>
        <StyledMenuItem onClick={handleExport} disabled={isPendingExportFormConfig}>
          <StyledListItemIcon>
            <FeatherIcon icon="download" width="20" height="20" />
          </StyledListItemIcon>
          <StyledListItemText>{t("forms.exportFormConfig")}</StyledListItemText>
        </StyledMenuItem>
        <BackdropLoader
          isVisible={isPendingExportFormConfig}
          label={t("forms.exportingFormConfig")}
        />
      </>
    )
  );
};

export default FormConfigExport;
